import { useUser } from "@/context/useUser";
import { getAccessToken } from "@/lib/storeManager";
import navigationRoutes from "@/utils/navigationRoutes";
import { useEffect, useRef, useState } from "react";
import {
  Outlet,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import CityCollabSettingService from "@/services/APIs/CityCollabSettingService";
import MMNavigationRoutes from "@/projects/Civi_Circle_Admin/utils/navigationRoutes";

const ProtectedRouter = () => {
  const { isAuthenticated } = useUser();
  const isLoggedIn = getAccessToken() !== null;
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const refer_code = searchParams.get("refer_code");

  // Route type checks
  const path = location.pathname;
  const isMMRoute = path.includes("/mm");
  const isMMRouteMobileView = path.includes("/Civi_Circle_Admin-mobileview");
  const isMMRouteAdmin = path.includes("/Civi_Circle_Admin-admin");
  const hasChapterId = path.match(/\/mm\/[^/]+/); // detect dynamic chapterId segment
  const [validatingInvite, setValidatingInvite] = useState(false);
  const hasNavigated = useRef(false); // to prevent double navigation

  useEffect(() => {
    if (hasNavigated.current) {
      return;
    } // stop multiple redirects
    if (isAuthenticated || isLoggedIn) {
      return;
    }

    const handleNavigation = async () => {
      // If invite link present â†’ validate it
      if (refer_code) {
        hasNavigated.current = true;
        setValidatingInvite(true);
        try {
          const response = await CityCollabSettingService.validateInviteToken({
            invite_code: refer_code,
          });

          if (response?.status === "success") {
            localStorage.setItem("OrganizationId", response.organization_id);
            localStorage.setItem(
              "MemberShipTypeId",
              response.membership_type_id
            );
            localStorage.setItem(
              "OrganizationName",
              response.organization_name
            );

            localStorage.setItem("DepartmentId", response.department_id);
            navigate(navigationRoutes.LOGIN, { replace: true });
          }
        } catch (err) {
          console.error("Invite validation failed:", err);
          navigate(navigationRoutes.LOGIN, { replace: true });
        } finally {
          setValidatingInvite(false);
        }
      } else if (isMMRouteAdmin) {
        navigate(MMNavigationRoutes.ADMIN_LOGIN_PAGE, { replace: true });
      } else if (isMMRoute) {
        navigate(MMNavigationRoutes.ADMIN_LOGIN_PAGE, { replace: true });
      } else {
        navigate(navigationRoutes.ADMIN_LOGIN_PAGE, { replace: true });
      }
    };
    handleNavigation();
  }, [
    isAuthenticated,
    isLoggedIn,
    refer_code,
    isMMRoute,
    isMMRouteAdmin,
    isMMRouteMobileView,
    hasChapterId,
    navigate,
  ]);

  if (validatingInvite) {
    return null; // or <div>Loading...</div>
  }

  // If authenticated or logged in, render protected content
  if (isAuthenticated || isLoggedIn) {
    return <Outlet />;
  }
};

export default ProtectedRouter;
